var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, TemplateRef } from "@angular/core";
import { ApiServices } from "src/app/apiServices.service";
import { URL_API_BR } from "src/app/app.api";
// var URL_API_BR = 'http://localhost:8089';
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";
var LoginsCenprotComponent = /** @class */ (function () {
    function LoginsCenprotComponent(api, router, modalService) {
        this.api = api;
        this.router = router;
        this.modalService = modalService;
        this.isFutureUser = false;
        this.isFutureUserRoot = false;
        this.logins = [];
        this.loginsFiltrados = [];
        this.permissoesPrecos = [];
        this.permissoesPrecosFiltrados = [];
        this.limitacoesConsultas = [];
        this.limitacoesConsultasFiltrados = [];
        this.permissoesCliente = {};
        this.loadingData = true;
        this.loadingPermissoes = true;
        this.loadingBillings = true;
        this.msgCadastro = "";
        this.msgCadastroClass = "alert-warning";
        this.msgCadastroBill = "";
        this.msgCadastroBillClass = "alert-warning";
        this.txtSubmitCadastro = "Salvar";
        this.enviandoCadastro = false;
        this.registroSelecionado = null;
        this.showLista = true;
        this.showForm = false;
        this.valorCredito = 0.0;
        this.totalUsado = 0;
        this.totalLimite = 0;
        this.descCredito = "";
        this.lancamentosFatura = [];
        this.sort = "companyName";
        this.order = "asc";
        this.columns = [
            {
                label: "Empresa",
                field: "companyName",
            },
            {
                label: "Contato",
                field: "contactName",
            },
            {
                label: "E-mail",
                field: "email",
            },
        ];
        this.columnsPermissoes = [
            {
                label: "Consulta",
                field: "query.name",
            },
        ];
        this.formCadastro = new FormGroup({
            name: new FormControl(null, [Validators.required]),
            email: new FormControl(null, [Validators.required, Validators.email]),
            document: new FormControl(null, [Validators.required]),
            companyName: new FormControl(null, [Validators.required]),
            phone: new FormControl("1100000000", [Validators.required]),
            pass: new FormControl(null, [Validators.required]),
            passConfirm: new FormControl(null, [Validators.required]),
        });
        this.formBilling = new FormGroup({
            contactName: new FormControl(null, [Validators.required]),
            phone: new FormControl(null, [Validators.required]),
            email: new FormControl(null, [Validators.required, Validators.email]),
            invoiceLimit: new FormControl(null, [Validators.required]),
        });
        this.savingClient = { saving: false, text: "", show: false };
        this.savingClientQueries = { saving: false, text: "", show: false };
    }
    LoginsCenprotComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.dadosUsuario.group != undefined) {
            this.api
                .get(URL_API_BR + "/site/group/" + this.dadosUsuario.group)
                .then(function (r) {
                if (r.type == "adm") {
                    _this.isFutureUser = true;
                    var usersRoot = ["5bae34ca5eb20c3ece0ca96e", "5ccb4c014274cc04e0c717b8"];
                    if (usersRoot.includes(_this.dadosUsuario._id)) {
                        _this.isFutureUserRoot = true;
                    }
                    _this.loadData();
                }
                else {
                    _this.router.navigate(["/painel"]);
                }
            });
        }
    };
    LoginsCenprotComponent.prototype.loadData = function () {
        var _this = this;
        this.loadingData = true;
        this.api.get(URL_API_BR + "/site/supplier-account/cenprot").then(function (r) {
            _this.logins = r;
            _this.totalUsado = _this.logins.reduce(function (acc, login) {
                return acc + (login.currentUsed || 0);
            }, 0);
            _this.totalLimite = _this.logins.reduce(function (acc, login) {
                return acc + (login.limitUseDay || 0);
            }, 0);
            _this.loginsFiltrados = _this.logins;
            _this.loadingData = false;
        });
    };
    LoginsCenprotComponent.prototype.checkLogin = function (login) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        login.verificandoLogin = true;
                        login.token_pendente = true;
                        return [4 /*yield*/, this.api.post(URL_API_BR + "/site/supplier-account/cenprot/get-token", __assign({}, login.payload))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginsCenprotComponent.prototype.validarToken = function (login) {
        return __awaiter(this, void 0, void 0, function () {
            var resultCheck;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(login.token && login.token.length == 6)) return [3 /*break*/, 2];
                        login.verificandoLogin = true;
                        return [4 /*yield*/, this.api.post(URL_API_BR + "/site/supplier-account/cenprot/validate-token", { documento: login.payload.documento, token: login.token })];
                    case 1:
                        resultCheck = _a.sent();
                        if (resultCheck.success && resultCheck.data.token) {
                            login.logado = true;
                            login.token_pendente = false;
                            this.loadData();
                        }
                        else {
                            login.verificandoLogin = false;
                            login.token_pendente = false;
                            login.token = "";
                            alert("Token inválido ou expirado. Tente novamente.");
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // validarToken
    LoginsCenprotComponent.prototype.filterLogins = function (e) {
        var _this = this;
        var value = e
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
        this.loginsFiltrados = this.logins.filter(function (e) {
            for (var _i = 0, _a = _this.columns; _i < _a.length; _i++) {
                var c = _a[_i];
                if (e[c.field]) {
                    var valueField = e[c.field]
                        .toString()
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                        .toLowerCase();
                    if (valueField.indexOf(value) !== -1) {
                        return true;
                    }
                }
            }
            return false;
        });
    };
    LoginsCenprotComponent.prototype.filterPermissoes = function (e) {
        var value = e
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
        this.permissoesPrecosFiltrados = this.permissoesPrecos.filter(function (e) {
            var valueField = e.query.name
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase();
            if (valueField.indexOf(value) !== -1) {
                return true;
            }
            return false;
        });
    };
    LoginsCenprotComponent.prototype.filterLimitacoes = function (e) {
        var value = e
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
        this.limitacoesConsultasFiltrados = this.limitacoesConsultas.filter(function (e) {
            var valueField = e.name
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase();
            if (valueField.indexOf(value) !== -1) {
                return true;
            }
            return false;
        });
    };
    LoginsCenprotComponent.prototype.abreForm = function () {
        this.msgCadastro = "";
        this.showForm = true;
        this.showLista = false;
        this.formCadastro = new FormGroup({
            name: new FormControl(null, [Validators.required]),
            email: new FormControl(null, [Validators.required, Validators.email]),
            document: new FormControl(null, [Validators.required]),
            companyName: new FormControl(null, [Validators.required]),
            phone: new FormControl(null, [Validators.required]),
            pass: new FormControl(null, [Validators.required]),
            passConfirm: new FormControl(null, [Validators.required]),
        });
        // this.formCadastro = new FormGroup({
        //   'name':new FormControl(null,[Validators.required]),
        //   'email':new FormControl(null,[Validators.required, Validators.email]),
        //   'document':new FormControl(null,[Validators.required]),
        //   'companyName':new FormControl(null,[Validators.required]),
        //   'phone':new FormControl('1100000000',[Validators.required]),
        //   'pass':new FormControl(null,[Validators.required]),
        //   'passConfirm':new FormControl(null,[Validators.required])
        // });
    };
    LoginsCenprotComponent.prototype.fechaForm = function () {
        this.showForm = false;
        this.showLista = true;
        this.msgCadastro = "";
        this.loadData();
    };
    LoginsCenprotComponent.prototype.faturamento = function (registro, template) {
        this.registroSelecionado = registro;
        this.modalRef = this.modalService.show(template, { class: "modal-lg" });
        this.carregaFaturamento();
    };
    LoginsCenprotComponent.prototype.carregaFaturamento = function () {
        this.loadingPermissoes = true;
        this.configFormCadastroBilling();
    };
    LoginsCenprotComponent.prototype.configFormCadastroBilling = function () {
        var _this = this;
        var clientBilling = {
            contactName: null,
            phone: null,
            email: null,
            invoiceLimit: null,
        };
        this.api
            .get(URL_API_BR + "/site/client-billing/" + this.registroSelecionado.billing)
            .then(function (r) {
            clientBilling = r;
            _this.formBilling = new FormGroup({
                contactName: new FormControl(clientBilling.contactName, [
                    Validators.required,
                ]),
                phone: new FormControl(clientBilling.phone, [Validators.required]),
                email: new FormControl(clientBilling.email, [
                    Validators.required,
                    Validators.email,
                ]),
                invoiceLimit: new FormControl(clientBilling.invoiceLimit, [
                    Validators.required,
                ]),
            });
            _this.loadingPermissoes = false;
            _this.carregaUltimosBillings();
        });
    };
    LoginsCenprotComponent.prototype.carregaUltimosBillings = function () {
        var _this = this;
        this.loadingBillings = true;
        this.lancamentosFatura = [];
        var urlBill = URL_API_BR + "/site/billing-client/last-by-client/" + this.registroSelecionado._id;
        this.api.get(urlBill).then(function (bill) {
            _this.lancamentosFatura = bill;
            _this.lancamentosFatura.sort(function (a, b) { return (a.createAt > b.createAt ? 1 : -1); });
            _this.loadingBillings = false;
        });
    };
    LoginsCenprotComponent.prototype.salvarCadastroBilling = function () {
        var _this = this;
        var values = this.formBilling.value;
        var billingData = {};
        var campos = ["email", "phone", "contactName", "invoiceLimit"];
        campos.forEach(function (campo) {
            billingData[campo] = _this.formCadastro.value[campo];
        });
        //if(this.dadosUsuario.client.billing){
        //billingData['_id']=this.registroSelecionado.billing;
        //}
        if (this.formBilling.valid) {
            this.enviandoCadastro = true;
            this.msgCadastroBill = "";
            this.txtSubmitCadastro = "Enviando...";
            this.api
                .put(URL_API_BR + "/site/client-billing/" + this.registroSelecionado.billing, values)
                .then(function (r) {
                // let clientData = {billing:r._id};
                // this.api.put(`${URL_API_BR}/api/client/${this.dadosUsuario.client._id}`,clientData)
                // .then(ruser=>{
                if (r) {
                    _this.msgCadastroBill = "Dados atualizados com sucesso";
                    _this.msgCadastroBillClass = "alert-success";
                    setTimeout(function () {
                        _this.msgCadastroBill = "";
                        if (_this.dadosUsuario.client.billing == undefined) {
                            //this.router.navigate(['/area-logada']);
                            _this.dadosUsuario.client.billing = r;
                        }
                    }, 3000);
                }
                else {
                    _this.msgCadastroBill = "Erro ao atualizar os Dados";
                    _this.msgCadastroBillClass = "alert-danger";
                }
                _this.enviandoCadastro = false;
                _this.txtSubmitCadastro = "Salvar";
                // })
                // .catch(r=>{
                //   this.msgCadastro='Ocorreu um erro na requisição';
                //   this.msgCadastroClass= 'alert-danger';
                //   this.enviandoCadastro=false;
                //   this.txtSubmitCadastro="Salvar";
                // })
            })
                .catch(function (r) {
                _this.msgCadastroBill = "Ocorreu um erro na requisição";
                _this.msgCadastroBillClass = "alert-danger";
                _this.enviandoCadastro = false;
                _this.txtSubmitCadastro = "Salvar";
            });
        }
        else {
            this.msgCadastroBill = "Verique os campos obrigatórios";
            this.msgCadastroBillClass = "alert-warning";
            var campos_1 = ["email", "phone", "contactName", "invoiceLimit"];
            campos_1.forEach(function (campo) {
                _this.formCadastro.controls[campo].markAsTouched();
            });
        }
    };
    LoginsCenprotComponent.prototype.permissoes = function (registro, template) {
        this.registroSelecionado = registro;
        this.modalRef = this.modalService.show(template, { class: "modal-lg" });
        this.carregaPermissoesPrecos();
    };
    LoginsCenprotComponent.prototype.carregaPermissoesPrecos = function () {
        var _this = this;
        this.loadingPermissoes = true;
        this.permissoesPrecos = [];
        this.permissoesPrecosFiltrados = [];
        this.permissoesCliente = {};
        var url = URL_API_BR + "/site/client-query/by-client/" + this.registroSelecionado._id;
        this.api.get(url).then(function (r) {
            _this.permissoesCliente = r[0];
            _this.permissoesPrecos = _this.permissoesCliente.queries;
            _this.permissoesPrecos.forEach(function (p) {
                p.showFeatures = false;
            });
            _this.permissoesPrecosFiltrados = _this.permissoesPrecos;
            _this.loadingPermissoes = false;
        });
    };
    LoginsCenprotComponent.prototype.limitacoes = function (registro, template) {
        this.registroSelecionado = registro;
        this.modalRef = this.modalService.show(template, { class: "modal-lg" });
        this.atualizaLimitacoes();
    };
    LoginsCenprotComponent.prototype.atualizaLimitacoes = function () {
        var _this = this;
        this.loadingPermissoes = true;
        this.limitacoesConsultas = [];
        this.limitacoesConsultasFiltrados = [];
        this.permissoesCliente = {};
        var url = URL_API_BR + "/site/client/get-limit-queries/" + this.registroSelecionado._id;
        this.api.get(url).then(function (r) {
            _this.limitacoesConsultas = r.rows.map(function (e) {
                e.add = 0;
                return e;
            });
            _this.limitacoesConsultasFiltrados = _this.limitacoesConsultas;
            _this.loadingPermissoes = false;
        });
    };
    LoginsCenprotComponent.prototype.resetarLimitacoes = function () {
        var _this = this;
        var payload = {
            client: this.registroSelecionado._id,
            queries: [],
        };
        for (var _i = 0, _a = this.limitacoesConsultas; _i < _a.length; _i++) {
            var query = _a[_i];
            var o = {
                code: query.code,
                qty: query.limitPerDay,
                reset: true,
            };
            payload.queries.push(o);
        }
        this.loadingPermissoes = true;
        var url = URL_API_BR + "/site/client/set-limit-queries";
        this.api.post(url, payload).then(function (r) {
            _this.atualizaLimitacoes();
            _this.registroSelecionado.lastResetLimitAt = Date.now();
        });
    };
    LoginsCenprotComponent.prototype.salvarCadastro = function () {
        var _this = this;
        var values = this.formCadastro.value;
        if (this.formCadastro.valid) {
            if (values["pass"] != values["passConfirm"]) {
                this.msgCadastro = "As senhas não estão iguais!";
                this.msgCadastroClass = "alert-danger";
                return;
            }
            //this.enviandoCadastro=true;
            this.msgCadastro = "";
            this.txtSubmitCadastro = "Enviando...";
            values["passTemp"] = true;
            this.api.get(URL_API_BR + "/site/group/by-type/user").then(function (r) {
                values["group"] = r[0]._id;
                _this.api
                    .post(URL_API_BR + "/site/client/newclient", values)
                    .then(function (r) {
                    console.log(r);
                    if (r.obj && r.obj._id) {
                        _this.msgCadastro = "Cadastro enviado com sucesso!";
                        _this.msgCadastroClass = "alert-success";
                        _this.enviandoCadastro = false;
                        _this.txtSubmitCadastro = "Salvar";
                        setTimeout(function () {
                            _this.msgCadastro = "";
                            _this.fechaForm();
                        }, 3000);
                    }
                    else {
                        if (r.err.errmsg &&
                            r.err.errmsg.indexOf("email_1 dup key") != -1) {
                            _this.msgCadastro = "E-mail já existente no cadastro.";
                        }
                        else {
                            _this.msgCadastro = r.msg;
                        }
                        _this.msgCadastroClass = "alert-danger";
                        _this.enviandoCadastro = false;
                        _this.txtSubmitCadastro = "Salvar";
                    }
                })
                    .catch(function (r) {
                    _this.msgCadastro = "Ocorreu um erro na requisição";
                    if (r.err.errmsg && r.err.errmsg.indexOf("email_1 dup key") != -1) {
                        _this.msgCadastro = "E-mail já existente no cadastro.";
                    }
                    _this.enviandoCadastro = false;
                    _this.txtSubmitCadastro = "Salvar";
                    _this.msgCadastroClass = "alert-danger";
                    _this.enviandoCadastro = false;
                    _this.txtSubmitCadastro = "Salvar";
                });
            });
        }
        else {
            this.msgCadastro = "Verique os campos obrigatórios";
            this.msgCadastroClass = "alert-warning";
            var campos = ["name", "email", "pass", "passConfirm"];
            campos.forEach(function (campo) {
                _this.formCadastro.controls[campo].markAsTouched();
            });
        }
    };
    LoginsCenprotComponent.prototype.save = function () {
        var _this = this;
        this.savingClientQueries.saving = true;
        this.savingClientQueries.text = "Salvando atualizações";
        var url = URL_API_BR + "/site/client-query/" + this.permissoesCliente._id;
        var payload = __assign({}, this.permissoesCliente);
        for (var _i = 0, _a = payload.queries; _i < _a.length; _i++) {
            var item = _a[_i];
            item.query = { _id: item.query._id, name: item.query.name };
        }
        // console.log(payload);
        this.api
            .put(url, this.permissoesCliente)
            .then(function (r) {
            _this.savingClientQueries.saving = true;
            _this.savingClientQueries.text = r.msg;
            setTimeout(function () {
                _this.savingClientQueries.saving = false;
                _this.savingClientQueries.text = "";
            }, 3000);
            console.log(r);
        })
            .catch(function (e) {
            _this.savingClientQueries.text = "Ocorreu um erro. Tente novamente";
            setTimeout(function () {
                _this.savingClientQueries.saving = false;
                _this.savingClientQueries.text = "";
            }, 3000);
            console.log("ERRO", e);
        });
    };
    LoginsCenprotComponent.prototype.saveClient = function (obj) {
        var url = URL_API_BR + "/site/client/" + obj._id;
        this.api
            .put(url, obj)
            .then(function (r) {
            console.log("OK");
        })
            .catch(function (e) { return console.log("ERRO", e); });
    };
    LoginsCenprotComponent.prototype.changeLimit = function (obj) {
        obj.changingLimit = true;
        var url = URL_API_BR + "/site/supplier-account/change-limit/" + obj._id;
        this.api
            .put(url, obj)
            .then(function (r) {
            console.log("OK");
            obj.changingLimit = false;
        })
            .catch(function (e) { return console.log("ERRO", e); });
    };
    LoginsCenprotComponent.prototype.zerarFeatures = function (query) {
        query.features.forEach(function (feature) {
            feature.price = 0.0;
        });
        this.save();
    };
    LoginsCenprotComponent.prototype.changeActive = function (obj, bool) {
        obj.active = bool;
        var url = URL_API_BR + "/site/supplier-account/change-active/" + obj._id;
        this.api
            .put(url, obj)
            .then(function (r) {
            console.log("OK");
        })
            .catch(function (e) { return console.log("ERRO", e); });
    };
    LoginsCenprotComponent.prototype.changePermission = function (obj, bool) {
        obj.permission = bool;
        this.save();
    };
    LoginsCenprotComponent.prototype.bloquearTodos = function (obj) {
        obj.forEach(function (o) {
            o.permission = false;
            if (o.features != undefined) {
                o.features.forEach(function (f) {
                    f.permission = false;
                });
            }
        });
        this.save();
    };
    LoginsCenprotComponent.prototype.liberarTodos = function (obj) {
        obj.forEach(function (o) {
            o.permission = true;
            if (o.features != undefined) {
                o.features.forEach(function (f) {
                    f.permission = true;
                });
            }
        });
        this.save();
    };
    LoginsCenprotComponent.prototype.verificarNovasConsultas = function () {
        var _this = this;
        this.loadingPermissoes = true;
        this.api
            .get(URL_API_BR + "/site/client/configure/permissions/" + this.registroSelecionado._id)
            .then(function (r) {
            setTimeout(function () { return _this.carregaPermissoesPrecos(); }, 2000);
        });
    };
    LoginsCenprotComponent.prototype.addCredito = function () {
        var _this = this;
        if (confirm("Deseja continuar com o crédito?")) {
            this.loadingBillings = true;
            var obj = {
                client: this.registroSelecionado._id,
                value: this.valorCredito,
                description: this.descCredito,
            };
            this.api.post(URL_API_BR + "/site/client/addCredit", obj).then(function (r) {
                _this.carregaUltimosBillings();
                _this.descCredito = "";
                _this.valorCredito = 0.0;
                //setTimeout(()=>this.carregaPermissoesPrecos(),2000);
            });
        }
    };
    LoginsCenprotComponent.prototype.excluir = function (registro) {
        var _this = this;
        if (confirm("Deseja mesmo excluir o cliente?")) {
            this.loadingData = true;
            this.api.get(URL_API_BR + "/site/deleteClient/" + registro._id).then(function (r) {
                console.log(r);
                setTimeout(function () { return _this.loadData(); }, 2000);
            });
        }
    };
    LoginsCenprotComponent.prototype.addQuery = function (query) {
        var _this = this;
        if (query.add && query.add > 0) {
            var client = this.registroSelecionado._id;
            query.isProcessing = true;
            var payload = {
                client: client,
                queries: [
                    {
                        code: query.code,
                        qty: query.add,
                        reset: false,
                    },
                ],
            };
            this.api
                .post(URL_API_BR + "/site/client/set-limit-queries", payload)
                .then(function (r) {
                query.isProcessing = false;
                _this.atualizaLimitacoes();
            });
        }
    };
    LoginsCenprotComponent.prototype.resetQuery = function (query) {
        var _this = this;
        var client = this.registroSelecionado._id;
        query.isProcessing = true;
        var payload = {
            client: client,
            queries: [
                {
                    code: query.code,
                    qty: query.limitPerDay,
                    reset: true,
                },
            ],
        };
        this.api
            .post(URL_API_BR + "/site/client/set-limit-queries", payload)
            .then(function (r) {
            query.isProcessing = false;
            _this.atualizaLimitacoes();
        });
    };
    LoginsCenprotComponent.prototype.zeroQuery = function (query) {
        var _this = this;
        var client = this.registroSelecionado._id;
        query.isProcessing = true;
        var payload = {
            client: client,
            queries: [
                {
                    code: query.code,
                    qty: 0,
                    reset: true,
                },
            ],
        };
        this.api
            .post(URL_API_BR + "/site/client/set-limit-queries", payload)
            .then(function (r) {
            query.isProcessing = false;
            _this.atualizaLimitacoes();
        });
    };
    return LoginsCenprotComponent;
}());
export { LoginsCenprotComponent };
